export default {
  zh: {
    invitationRecords: '邀请记录',
    inviteFriends: '邀请好友',
    referrals: '位',
    numDescribe: '目前为止，您已邀请的好友数量',
    reward: '奖励天数',
    days: '天',
    CNY: '￥',
    instructions: '好友充值成功以后，您和好友都将获得免费时长奖励'
  },
  en: {
    invitationRecords: 'Invitation Records',
    inviteFriends: 'Invite Friends',
    referrals: 'Friend | Friends',
    numDescribe: 'The number of friends you have invited',
    reward: 'Rewards',
    days: 'Day | Days',
    USD: '$',
    instructions: 'Both of you will get free VIP service time once your friend successfully purchase a plan'
  }
}



// WEBPACK FOOTER //
// ./src/views/affiliate/lang.js